import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import * as XLSX from 'xlsx';
import {
  Users,
  Upload,
  Plus,
  Search,
  RefreshCw,
  AlertCircle,
  CheckCircle,
  Download,
  Edit,
  Trash2,
  FileSpreadsheet
} from 'lucide-react';

function AgentSettlement() {
  const dispatch = useDispatch();
  const MyData = useSelector((state) => state.MyData);

  const [loading, setLoading] = useState(false);
  const [settlementData, setSettlementData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [message, setMessage] = useState({ type: '', text: '' });
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [parsedData, setParsedData] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(new Date().toISOString().slice(0, 7)); // YYYY-MM 형식
  const [availableMonths, setAvailableMonths] = useState([]);
  const [monthData, setMonthData] = useState([]); // 월 목록 데이터 (상태 포함)
  const [existingDataCount, setExistingDataCount] = useState(0);
  const [showUploadModeModal, setShowUploadModeModal] = useState(false);
  const [monthStatus, setMonthStatus] = useState('active'); // 정산월 상태

  // 은행 데이터 (전역 변수)
  const bankData = [
    { "code": "455", "bank_name": "AIA생명" },
    { "code": "405", "bank_name": "AIG손해보험" },
    { "code": "302", "bank_name": "BNK캐피탈" },
    { "code": "224", "bank_name": "BNK투자증권" },
    { "code": "404", "bank_name": "BNP파리바 카디프생명" },
    { "code": "060", "bank_name": "BOA은행" },
    { "code": "361", "bank_name": "BC카드" },
    { "code": "279", "bank_name": "DB금융투자" },
    { "code": "457", "bank_name": "DB생명보험" },
    { "code": "443", "bank_name": "DB손해보험" },
    { "code": "274", "bank_name": "DS투자증권" },
    { "code": "054", "bank_name": "HSBC은행" },
    { "code": "225", "bank_name": "IBK투자증권" },
    { "code": "305", "bank_name": "JB우리캐피탈" },
    { "code": "458", "bank_name": "KDB생명보험" },
    { "code": "450", "bank_name": "KB라이프" },
    { "code": "444", "bank_name": "KB손해보험" },
    { "code": "218", "bank_name": "KB증권" },
    { "code": "308", "bank_name": "KB캐피탈" },
    { "code": "371", "bank_name": "NH농협카드" },
    { "code": "440", "bank_name": "NH농협생명" },
    { "code": "449", "bank_name": "NH농협손해보험" },
    { "code": "011", "bank_name": "NH농협은행" },
    { "code": "306", "bank_name": "NH농협캐피탈" },
    { "code": "247", "bank_name": "NH투자증권" },
    { "code": "272", "bank_name": "NH선물" },
    { "code": "023", "bank_name": "SC제일은행" },
    { "code": "266", "bank_name": "SK증권" },
    { "code": "039", "bank_name": "경남은행" },
    { "code": "034", "bank_name": "광주은행" },
    { "code": "364", "bank_name": "광주카드" },
    { "code": "433", "bank_name": "교보라이프플래닛생명" },
    { "code": "436", "bank_name": "교보생명" },
    { "code": "261", "bank_name": "교보증권" },
    { "code": "066", "bank_name": "교통은행" },
    { "code": "004", "bank_name": "국민은행" },
    { "code": "381", "bank_name": "국민카드" },
    { "code": "003", "bank_name": "기업은행" },
    { "code": "077", "bank_name": "기술보증기금" },
    { "code": "012", "bank_name": "농축협" },
    { "code": "227", "bank_name": "다올투자증권" },
    { "code": "267", "bank_name": "대신증권" },
    { "code": "065", "bank_name": "대화은행" },
    { "code": "055", "bank_name": "도이치은행" },
    { "code": "402", "bank_name": "동양생명" },
    { "code": "435", "bank_name": "라이나생명" },
    { "code": "223", "bank_name": "리딩투자증권" },
    { "code": "445", "bank_name": "롯데손해보험" },
    { "code": "368", "bank_name": "롯데카드" },
    { "code": "303", "bank_name": "롯데캐피탈" },
    { "code": "287", "bank_name": "메리츠증권" },
    { "code": "448", "bank_name": "메리츠화재" },
    { "code": "052", "bank_name": "모간스탠리은행" },
    { "code": "059", "bank_name": "미래에셋대우" },
    { "code": "290", "bank_name": "미래에셋증권" },
    { "code": "263", "bank_name": "미쓰비시도쿄UFJ은행" },
    { "code": "020", "bank_name": "부산은행" },
    { "code": "081", "bank_name": "사람들" },
    { "code": "007", "bank_name": "새마을금고" },
    { "code": "045", "bank_name": "새마을금고중앙회" },
    { "code": "064", "bank_name": "산림조합" },
    { "code": "034", "bank_name": "산업은행" },
    { "code": "002", "bank_name": "신한은행" },
    { "code": "088", "bank_name": "신협" },
    { "code": "048", "bank_name": "신협중앙회" },
    { "code": "027", "bank_name": "씨티은행" },
    { "code": "020", "bank_name": "우리은행" },
    { "code": "071", "bank_name": "우체국" },
    { "code": "050", "bank_name": "저축은행" },
    { "code": "037", "bank_name": "전북은행" },
    { "code": "035", "bank_name": "제주은행" },
    { "code": "090", "bank_name": "카카오뱅크" },
    { "code": "089", "bank_name": "케이뱅크" },
    { "code": "092", "bank_name": "토스뱅크" },
    { "code": "001", "bank_name": "하나은행" },
    { "code": "054", "bank_name": "HSBC은행" },
    { "code": "055", "bank_name": "도이치은행" },
    { "code": "060", "bank_name": "BOA은행" },
    { "code": "066", "bank_name": "교통은행" },
    { "code": "065", "bank_name": "대화은행" },
    { "code": "077", "bank_name": "기술보증기금" },
    { "code": "081", "bank_name": "사람들" },
    { "code": "088", "bank_name": "신협" },
    { "code": "089", "bank_name": "케이뱅크" },
    { "code": "090", "bank_name": "카카오뱅크" },
    { "code": "092", "bank_name": "토스뱅크" }
  ];

  // 직접 추가 폼 데이터
  const [formData, setFormData] = useState({
    agentCode: '',
    accountHolder: '',
    accountNumber: '',
    bankName: '',
    depositMemo: '',
    withdrawalMemo: '',
    amount: ''
  });

  // 컴포넌트 마운트 시 실행
  useEffect(() => {
    dispatch(change_Current_Location('에이전트 정산'));
    dispatch(changeHeaderTitle('에이전트 정산'));
    loadSettlementData();
    loadAvailableMonths();
  }, [dispatch]);

  // 토스트 메시지 자동 사라짐
  useEffect(() => {
    if (message.text) {
      const timer = setTimeout(() => {
        setMessage({ type: '', text: '' });
      }, 5000); // 5초 후 자동 사라짐

      return () => clearTimeout(timer);
    }
  }, [message.text]);

  // 선택된 월이 변경될 때마다 데이터 다시 로드 및 상태 확인
  useEffect(() => {
    loadSettlementData();
    checkMonthStatus(selectedMonth);
  }, [selectedMonth, monthData]);

  // 검색어 변경 시 필터링
  useEffect(() => {
    if (searchTerm === '') {
      setFilteredData(settlementData);
    } else {
      const filtered = settlementData.filter(item =>
        item.agentCode?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.accountHolder?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.accountNumber?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.bankName?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [searchTerm, settlementData]);

  // 정산 데이터 로드
  const loadSettlementData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(process.env.REACT_APP_API + "/api/agent-settlement/list", {
        params: { settlementMonth: selectedMonth },
        withCredentials: true,
      });

      if (response.data.code === 1000) {
        // API 응답 데이터를 컴포넌트에서 사용하는 필드명으로 변환
        const transformedData = (response.data.data || []).map(item => ({
          id: item.id,
          agentCode: item.agent_code,
          accountHolder: item.account_holder,
          accountNumber: item.account_number,
          bankName: item.bank_name,
          depositMemo: item.deposit_memo || '',
          withdrawalMemo: item.withdrawal_memo || '',
          amount: item.amount,
          status: item.status || 'pending',
          createdAt: item.created_at,
          createdBy: item.created_by,
          updatedAt: item.updated_at,
          updatedBy: item.updated_by
        }));
        setSettlementData(transformedData);
      } else {
        setMessage({ type: 'error', text: response.data.msg || '데이터 로드에 실패했습니다.' });
      }
    } catch (error) {
      console.error('데이터 로드 오류:', error);
      setMessage({ type: 'error', text: '데이터 로드 중 오류가 발생했습니다.' });
    } finally {
      setLoading(false);
    }
  };

  // 사용 가능한 월 목록 로드
  const loadAvailableMonths = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_API + "/api/agent-settlement/months", {
        withCredentials: true,
      });

      if (response.data.code === 1000) {
        // 원본 월 데이터 저장 (상태 정보 포함)
        setMonthData(response.data.data || []);
        
        // 월 목록 데이터 변환 (문자열 배열로 변환)
        const months = (response.data.data || []).map(item => {
          if (typeof item === 'string') {
            return item;
          } else if (typeof item === 'object' && item.settlement_month) {
            return item.settlement_month;
          } else if (typeof item === 'object' && item.month) {
            return item.month;
          }
          return String(item);
        });
        setAvailableMonths(months);
      }
    } catch (error) {
      console.error('월 목록 로드 오류:', error);
    }
  };

  // 정산월 상태 확인 (월 목록에서 찾기)
  const checkMonthStatus = (month) => {
    // 월 목록에서 현재 선택된 월의 상태를 찾아서 설정
    const monthInfo = monthData.find(item => {
      const monthValue = item.settlement_month || item.month || item;
      return monthValue === month;
    });
    
    if (monthInfo && typeof monthInfo === 'object') {
      // 객체인 경우 status 필드 확인
      setMonthStatus(monthInfo.status || 'inactive');
    } else {
      // 문자열이거나 상태 정보가 없는 경우 기본값
      setMonthStatus('active');
    }
  };

  // 파일 선택 핸들러
  const handleFileSelect = (event) => {
    if (monthStatus !== 'active') {
      setMessage({ type: 'error', text: '정산월이 활성 상태가 아니어서 업로드할 수 없습니다.' });
      return;
    }
    
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      handleFileParse(file);
    }
  };

  // 파일 파싱
  const handleFileParse = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0]; // 첫 번째 시트 사용
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        // 헤더 제거하고 데이터만 추출
        const headers = jsonData[0];
        const rows = jsonData.slice(1).filter(row => row.some(cell => cell !== undefined && cell !== ''));

        // 유효한 은행명 목록 (bankData에서 추출)
        const validBankNames = bankData.map(bank => bank.bank_name);

        // 데이터 변환
        const parsedRows = rows.map((row, index) => {
          const bankName = row[3] || '';
          const isValidBankName = validBankNames.includes(bankName);

          return {
            id: `temp_${index}`,
            agentCode: row[0] || '',
            accountHolder: row[1] || '',
            accountNumber: row[2] || '',
            bankName: bankName,
            depositMemo: row[4] || '',
            withdrawalMemo: row[5] || '',
            amount: row[6] || '',
            isValid: !!(row[0] && row[1] && row[2] && row[3] && row[6] && isValidBankName), // 필수 필드 + 은행명 유효성 검증
            bankNameValid: isValidBankName // 은행명 유효성 별도 표시
          };
        });

        setParsedData(parsedRows);

        // 기존 데이터 개수 확인
        const existingCount = settlementData.length;
        setExistingDataCount(existingCount);

        if (existingCount > 0) {
          setShowUploadModeModal(true);
        } else {
          setShowPreview(true);
        }

        setMessage({ type: 'success', text: `${parsedRows.length}개의 데이터를 읽었습니다.` });
      } catch (error) {
        console.error('파일 파싱 오류:', error);
        setMessage({ type: 'error', text: '파일을 읽는 중 오류가 발생했습니다.' });
      }
    };
    reader.readAsArrayBuffer(file);
  };

  // 업로드 모드 선택 핸들러
  const handleUploadModeSelect = (mode) => {
    setShowUploadModeModal(false);
    setShowPreview(true);
    // 미리보기에서 선택된 모드로 업로드할 수 있도록 상태 저장
    setParsedData(prev => prev.map(item => ({ ...item, uploadMode: mode })));
  };

  // 최종 서버 업로드
  const handleFinalUpload = async (uploadMode = 'add') => {
    const validData = parsedData.filter(item => item.isValid).map(item => ({
      ...item,
      settlementMonth: selectedMonth
    }));

    if (validData.length === 0) {
      setMessage({ type: 'error', text: '유효한 데이터가 없습니다.' });
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(process.env.REACT_APP_API + "/api/agent-settlement/bulk-add", {
        data: validData,
        mode: uploadMode // 'add', 'replace', 'merge'
      }, {
        withCredentials: true,
      });

      if (response.data.code === 1000) {
        const modeText = uploadMode === 'replace' ? '교체' : uploadMode === 'merge' ? '병합' : '추가';
        setMessage({ type: 'success', text: `${validData.length}개의 데이터가 성공적으로 ${modeText}되었습니다.` });
        setShowPreview(false);
        setParsedData([]);
        setSelectedFile(null);
        loadSettlementData();
        loadAvailableMonths();
      } else {
        setMessage({ type: 'error', text: response.data.msg || '데이터 업로드에 실패했습니다.' });
      }
    } catch (error) {
      console.error('데이터 업로드 오류:', error);
      setMessage({ type: 'error', text: '데이터 업로드 중 오류가 발생했습니다.' });
    } finally {
      setLoading(false);
    }
  };

  // 직접 데이터 추가
  const handleAddData = async () => {
    if (monthStatus !== 'active') {
      setMessage({ type: 'error', text: '정산월이 활성 상태가 아니어서 추가할 수 없습니다.' });
      return;
    }

    if (!formData.agentCode || !formData.accountHolder || !formData.accountNumber || !formData.bankName || !formData.amount) {
      setMessage({ type: 'error', text: '필수 항목을 입력해주세요.' });
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(process.env.REACT_APP_API + "/api/agent-settlement/add", {
        ...formData,
        settlementMonth: selectedMonth
      }, {
        withCredentials: true,
      });

      if (response.data.code === 1000) {
        setMessage({ type: 'success', text: '데이터가 성공적으로 추가되었습니다.' });
        setFormData({
          agentCode: '',
          accountHolder: '',
          accountNumber: '',
          bankName: '',
          depositMemo: '',
          withdrawalMemo: '',
          amount: ''
        });
        setShowAddModal(false);
        loadSettlementData();
      } else {
        setMessage({ type: 'error', text: response.data.msg || '데이터 추가에 실패했습니다.' });
      }
    } catch (error) {
      console.error('데이터 추가 오류:', error);
      setMessage({ type: 'error', text: '데이터 추가 중 오류가 발생했습니다.' });
    } finally {
      setLoading(false);
    }
  };

  // 데이터 삭제
  const handleDeleteData = async (id) => {
    if (monthStatus !== 'active') {
      setMessage({ type: 'error', text: '정산월이 활성 상태가 아니어서 삭제할 수 없습니다.' });
      return;
    }

    if (!window.confirm('정말로 삭제하시겠습니까?')) return;

    try {
      setLoading(true);
      const response = await axios.delete(process.env.REACT_APP_API + `/api/agent-settlement/delete/${id}`, {
        withCredentials: true,
      });

      if (response.data.code === 1000) {
        setMessage({ type: 'success', text: '데이터가 성공적으로 삭제되었습니다.' });
        loadSettlementData();
      } else {
        setMessage({ type: 'error', text: response.data.msg || '데이터 삭제에 실패했습니다.' });
      }
    } catch (error) {
      console.error('데이터 삭제 오류:', error);
      setMessage({ type: 'error', text: '데이터 삭제 중 오류가 발생했습니다.' });
    } finally {
      setLoading(false);
    }
  };

  // 엑셀 템플릿 다운로드 (하드코딩)
  const downloadTemplate = () => {
    try {
      // 워크북 생성
      const workbook = XLSX.utils.book_new();

      // 1. 데이터 입력 시트
      const dataSheet = [
        ['에이전트코드', '예금주명', '계좌번호', '은행명', '입금적요', '출금적요', '금액'],
        ['AGENT001', '홍길동', '123456789012', '국민은행', '1월 정산금', '에이전트 수수료', '1000000'],
        ['AGENT002', '김철수', '987654321098', '신한은행', '2월 정산금', '에이전트 수수료', '2000000']
      ];

      // 2. 은행명 목록 시트 (실제 데이터 기반)
      // bankData는 전역 변수로 이미 정의됨

      // 은행 데이터를 구분별로 분류
      const bankCategories = {
        '주요 시중은행': [],
        '인터넷전문은행': [],
        '지방은행': [],
        '증권사': [],
        '카드사': [],
        '캐피탈': [],
        '생명보험': [],
        '손해보험': [],
        '기타금융기관': []
      };

      bankData.forEach(bank => {
        const name = bank.bank_name;
        if (name.includes('은행') && !name.includes('증권') && !name.includes('카드') && !name.includes('캐피탈')) {
          if (name.includes('카카오뱅크') || name.includes('케이뱅크') || name.includes('토스뱅크')) {
            bankCategories['인터넷전문은행'].push(bank);
          } else if (name.includes('대구') || name.includes('부산') || name.includes('광주') || name.includes('제주') || name.includes('전북') || name.includes('경남')) {
            bankCategories['지방은행'].push(bank);
          } else {
            bankCategories['주요 시중은행'].push(bank);
          }
        } else if (name.includes('증권')) {
          bankCategories['증권사'].push(bank);
        } else if (name.includes('카드')) {
          bankCategories['카드사'].push(bank);
        } else if (name.includes('캐피탈')) {
          bankCategories['캐피탈'].push(bank);
        } else if (name.includes('생명')) {
          bankCategories['생명보험'].push(bank);
        } else if (name.includes('손해') || name.includes('화재') || name.includes('해상')) {
          bankCategories['손해보험'].push(bank);
        } else {
          bankCategories['기타금융기관'].push(bank);
        }
      });

      // 시트 데이터 생성
      const bankListSheet = [
        ['은행명 목록 (정확한 은행명을 입력하세요)', '', '', '', '', '', ''],
        ['', '', '', '', '', '', ''],
        ['구분', '은행명', '코드', '비고', '', '', ''],
        ['', '', '', '', '', '', '']
      ];

      // 각 카테고리별로 데이터 추가
      Object.keys(bankCategories).forEach(category => {
        if (bankCategories[category].length > 0) {
          bankListSheet.push([category, '', '', '', '', '', '']);
          bankCategories[category].forEach(bank => {
            bankListSheet.push(['', bank.bank_name, bank.code, '', '', '', '']);
          });
          bankListSheet.push(['', '', '', '', '', '', '']);
        }
      });

      // 사용 안내 추가
      bankListSheet.push(['', '', '', '', '', '', '']);
      bankListSheet.push(['사용 안내', '', '', '', '', '', '']);
      bankListSheet.push(['- 은행명은 정확히 입력해야 합니다', '', '', '', '', '', '']);
      bankListSheet.push(['- 코드는 입력하지 마세요', '', '', '', '', '', '']);
      bankListSheet.push(['- 은행명은 정확히 일치해야 합니다', '', '', '', '', '', '']);
      bankListSheet.push(['- 예: "국민은행" (O), "KB국민은행" (X)', '', '', '', '', '', '']);
      bankListSheet.push(['- 총 ' + bankData.length + '개 금융기관 지원', '', '', '', '', '', '']);

      // 시트들을 워크북에 추가
      const ws1 = XLSX.utils.aoa_to_sheet(dataSheet);
      const ws2 = XLSX.utils.aoa_to_sheet(bankListSheet);

      // 시트 이름 설정
      XLSX.utils.book_append_sheet(workbook, ws1, '데이터입력');
      XLSX.utils.book_append_sheet(workbook, ws2, '은행명목록');

      // 데이터 유효성 검사 설정 (은행명 열에만 적용)
      const bankNames = bankData.map(bank => bank.bank_name);

      // 데이터입력 시트의 D열(은행명)에 데이터 유효성 검사 적용
      // D2부터 D1000까지 (헤더 제외)
      const validationRange = `D2:D1000`;

      // 데이터 유효성 검사 설정
      if (!ws1['!dataValidation']) {
        ws1['!dataValidation'] = [];
      }

      ws1['!dataValidation'].push({
        ref: validationRange,
        type: 'list',
        allowBlank: true,
        formula1: `은행명목록!$B$4:$B$${bankData.length + 3}`, // 은행명목록 시트의 B열 참조
        showErrorMessage: true,
        errorTitle: '잘못된 은행명',
        error: '은행명목록 탭에서 유효한 은행명을 선택하세요.',
        showInputMessage: true,
        promptTitle: '은행명 선택',
        prompt: '은행명목록 탭의 목록에서 선택하거나 직접 입력하세요.'
      });

      // 엑셀 파일 생성 및 다운로드
      XLSX.writeFile(workbook, 'agent_settlement_template.xlsx');

      setMessage({ type: 'success', text: '템플릿이 성공적으로 다운로드되었습니다.' });
    } catch (error) {
      console.error('템플릿 생성 오류:', error);
      setMessage({ type: 'error', text: '템플릿 생성 중 오류가 발생했습니다.' });
    }
  };

  // 금액 포맷팅
  const formatAmount = (amount) => {
    if (!amount && amount !== 0) return '0';
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    return new Intl.NumberFormat('ko-KR').format(numAmount);
  };

  // 날짜 포맷팅
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      return new Date(dateString).toLocaleDateString('ko-KR');
    } catch (error) {
      return '-';
    }
  };

  // 상태별 스타일
  const getStatusStyle = (status) => {
    switch (status) {
      case 'completed':
        return 'status-completed';
      case 'pending':
        return 'status-pending';
      case 'cancelled':
        return 'status-cancelled';
      default:
        return 'status-unknown';
    }
  };


  return (
    <div className="agent-settlement-container">
      {/* 토스트 메시지 */}
      {message.text && (
        <div className={`toast ${message.type === 'success' ? 'toast-success' : 'toast-error'}`}>
          <div className="toast-content">
            <div className="toast-icon">
              {message.type === 'success' ? <CheckCircle size={20} /> : <AlertCircle size={20} />}
            </div>
            <div className="toast-message">
              <div className="toast-title">
                {message.type === 'success' ? '성공' : '오류'}
              </div>
              <div className="toast-text">{message.text}</div>
            </div>
            <button
              className="toast-close"
              onClick={() => setMessage({ type: '', text: '' })}
            >
              ×
            </button>
          </div>
        </div>
      )}


      {/* 통계 카드 */}
      <div className="month-stats">
        <div className="stat-card">
          <div className="stat-icon">
            <Users size={24} />
          </div>
          <div className="stat-content">
            <div className="stat-value">{filteredData.length}</div>
            <div className="stat-label">총 에이전트</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">
            <CheckCircle size={24} />
          </div>
          <div className="stat-content">
            <div className="stat-value">{filteredData.filter(item => item.status === 'completed').length}</div>
            <div className="stat-label">완료</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">
            <AlertCircle size={24} />
          </div>
          <div className="stat-content">
            <div className="stat-value">{filteredData.filter(item => item.status === 'pending').length}</div>
            <div className="stat-label">대기</div>
          </div>
        </div>
      </div>

      {/* 검색 및 액션 버튼들 */}
      <div className="search-section">
        <div className="search-box">
          <Search size={20} />
          <input
            type="text"
            placeholder="에이전트코드, 예금주명, 계좌번호, 은행명으로 검색..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="action-buttons">
          <label htmlFor="file-upload" className={`btn ${monthStatus === 'active' ? 'btn-primary' : 'btn-disabled'}`}>
            <Upload size={20} />
            엑셀 업로드
          </label>
          <input
            id="file-upload"
            type="file"
            accept=".xlsx,.xls"
            onChange={handleFileSelect}
            disabled={monthStatus !== 'active'}
            style={{ display: 'none' }}
          />
          <button className="btn btn-outline" onClick={downloadTemplate}>
            <Download size={20} />
            템플릿 다운로드
          </button>
          <button 
            className={`btn ${monthStatus === 'active' ? 'btn-outline' : 'btn-disabled'}`} 
            onClick={() => setShowAddModal(true)}
            disabled={monthStatus !== 'active'}
          >
            <Plus size={20} />
            직접 추가
          </button>
        </div>
      </div>

      {/* 데이터 미리보기 섹션 */}
      {showPreview && (
        <div className="preview-section">
          <div className="preview-header">
            <h3>데이터 미리보기</h3>
            <div className="preview-actions">
              <button
                className="btn btn-outline"
                onClick={() => {
                  setShowPreview(false);
                  setParsedData([]);
                  setSelectedFile(null);
                }}
              >
                취소
              </button>
              <button
                className="btn btn-primary"
                onClick={() => handleFinalUpload(parsedData[0]?.uploadMode || 'add')}
                disabled={loading}
              >
                {loading ? '업로드 중...' : `유효한 ${parsedData.filter(item => item.isValid).length}개 데이터 업로드`}
              </button>
            </div>
          </div>
          <div className="preview-info">
            <div className="file-info">
              <FileSpreadsheet size={20} />
              <span><strong>파일:</strong> {selectedFile?.name}</span>
              {parsedData[0]?.uploadMode && (
                <span className="upload-mode-badge">
                  {parsedData[0].uploadMode === 'add' ? '추가' :
                    parsedData[0].uploadMode === 'replace' ? '교체' : '병합'} 모드
                </span>
              )}
            </div>
            <p>총 {parsedData.length}개의 데이터 중 유효한 데이터: {parsedData.filter(item => item.isValid).length}개</p>
            <p className="text-sm text-gray-600">빨간색으로 표시된 행은 필수 정보가 누락된 데이터입니다.</p>
          </div>
          <div className="preview-table">
            <table>
              <thead>
                <tr>
                  <th>상태</th>
                  <th>에이전트코드</th>
                  <th>예금주명</th>
                  <th>계좌번호</th>
                  <th>은행명</th>
                  <th>입금적요</th>
                  <th>출금적요</th>
                  <th>금액</th>
                </tr>
              </thead>
              <tbody>
                {parsedData.map((item, index) => (
                  <tr key={index} className={!item.isValid ? 'invalid-row' : ''}>
                    <td>
                      {item.isValid ? (
                        <CheckCircle size={16} className="text-green-500" />
                      ) : (
                        <AlertCircle size={16} className="text-red-500" />
                      )}
                    </td>
                    <td>{String(item.agentCode || '')}</td>
                    <td>{String(item.accountHolder || '')}</td>
                    <td>{String(item.accountNumber || '')}</td>
                    <td className={!item.bankNameValid ? 'invalid-bank-name' : ''}>
                      {String(item.bankName || '')}
                      {!item.bankNameValid && (
                        <span className="bank-error-tooltip">유효하지 않은 은행명</span>
                      )}
                    </td>
                    <td>{String(item.depositMemo || '')}</td>
                    <td>{String(item.withdrawalMemo || '')}</td>
                    <td className="amount">{formatAmount(item.amount)}원</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* 데이터 테이블 */}
      <div className="data-table">
        <div className="table-header">
          <div className="month-selector">
            <label htmlFor="month-select">정산월:</label>
            <select
              id="month-select"
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
              className="month-select"
            >
              {availableMonths.map((month, index) => (
                <option key={month || index} value={month || ''}>
                  {String(month || '')}
                </option>
              ))}
            </select>
            <div className={`month-status ${monthStatus === 'active' ? 'status-active' : 'status-inactive'}`}>
              {monthStatus === 'active' ? '활성' : '비활성'}
            </div>
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th>에이전트코드</th>
              <th>예금주명</th>
              <th>계좌번호</th>
              <th>은행명</th>
              <th>입금적요</th>
              <th>출금적요</th>
              <th>금액</th>
              <th>상태</th>
              <th>등록일</th>
              <th>액션</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="10" className="loading-state">
                  <div className="loading-spinner"></div>
                  데이터를 불러오는 중...
                </td>
              </tr>
            ) : filteredData.length === 0 ? (
              <tr>
                <td colSpan="10" className="empty-state">
                  데이터가 없습니다.
                </td>
              </tr>
            ) : (
              filteredData.map((item) => (
                <tr key={item.id || Math.random()}>
                  <td>{String(item.agentCode || '')}</td>
                  <td>{String(item.accountHolder || '')}</td>
                  <td>{String(item.accountNumber || '')}</td>
                  <td>{String(item.bankName || '')}</td>
                  <td>{String(item.depositMemo || '')}</td>
                  <td>{String(item.withdrawalMemo || '')}</td>
                  <td className="amount">{formatAmount(item.amount)}원</td>
                  <td>
                    <span className={`status ${getStatusStyle(item.status)}`}>
                      {item.status === 'completed' ? '완료' :
                        item.status === 'pending' ? '대기' :
                          item.status === 'cancelled' ? '취소' : '알 수 없음'}
                    </span>
                  </td>
                  <td>{formatDate(item.createdAt)}</td>
                  <td>
                    <button
                      className={`btn-icon ${monthStatus === 'active' ? 'btn-danger' : 'btn-disabled'}`}
                      onClick={() => handleDeleteData(item.id)}
                      disabled={monthStatus !== 'active'}
                      title={monthStatus === 'active' ? '삭제' : '정산월이 비활성 상태입니다'}
                    >
                      <Trash2 size={16} />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* 직접 추가 모달 */}
      {showAddModal && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h3>데이터 직접 추가</h3>
              <button
                className="btn-close"
                onClick={() => setShowAddModal(false)}
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>에이전트코드 *</label>
                <input
                  type="text"
                  value={formData.agentCode}
                  onChange={(e) => setFormData({ ...formData, agentCode: e.target.value })}
                  placeholder="에이전트코드를 입력하세요"
                />
              </div>
              <div className="form-group">
                <label>예금주명 *</label>
                <input
                  type="text"
                  value={formData.accountHolder}
                  onChange={(e) => setFormData({ ...formData, accountHolder: e.target.value })}
                  placeholder="예금주명을 입력하세요"
                />
              </div>
              <div className="form-group">
                <label>계좌번호 *</label>
                <input
                  type="text"
                  value={formData.accountNumber}
                  onChange={(e) => setFormData({ ...formData, accountNumber: e.target.value })}
                  placeholder="계좌번호를 입력하세요"
                />
              </div>
              <div className="form-group">
                <label>은행명 *</label>
                <select
                  value={formData.bankName}
                  onChange={(e) => setFormData({ ...formData, bankName: e.target.value })}
                >
                  <option value="">은행을 선택하세요</option>
                  {bankData.map(bank => (
                    <option key={bank.code} value={bank.bank_name}>
                      {bank.bank_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>입금적요</label>
                <input
                  type="text"
                  value={formData.depositMemo}
                  onChange={(e) => setFormData({ ...formData, depositMemo: e.target.value })}
                  placeholder="입금적요를 입력하세요"
                />
              </div>
              <div className="form-group">
                <label>출금적요</label>
                <input
                  type="text"
                  value={formData.withdrawalMemo}
                  onChange={(e) => setFormData({ ...formData, withdrawalMemo: e.target.value })}
                  placeholder="출금적요를 입력하세요"
                />
              </div>
              <div className="form-group">
                <label>금액 *</label>
                <input
                  type="number"
                  value={formData.amount}
                  onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
                  placeholder="금액을 입력하세요"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-outline"
                onClick={() => setShowAddModal(false)}
              >
                취소
              </button>
              <button
                className="btn btn-primary"
                onClick={handleAddData}
                disabled={loading}
              >
                {loading ? '추가 중...' : '추가'}
              </button>
            </div>
          </div>
        </div>
      )}


      {/* 업로드 모드 선택 모달 */}
      {showUploadModeModal && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h3>업로드 모드 선택</h3>
              <button
                className="btn-close"
                onClick={() => {
                  setShowUploadModeModal(false);
                  setParsedData([]);
                  setSelectedFile(null);
                }}
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="upload-mode-info">
                <p><strong>현재 {selectedMonth}월에 {existingDataCount}개의 데이터가 있습니다.</strong></p>
                <p>새로 업로드할 데이터({parsedData.length}개)를 어떻게 처리하시겠습니까?</p>
              </div>

              <div className="upload-mode-options">
                <div className="mode-option" onClick={() => handleUploadModeSelect('add')}>
                  <div className="mode-icon">
                    <Plus size={24} />
                  </div>
                  <div className="mode-content">
                    <h4>추가 (Add)</h4>
                    <p>기존 데이터에 새 데이터를 추가합니다. 중복이 있을 수 있습니다.</p>
                    <span className="mode-result">결과: {existingDataCount + parsedData.length}개 데이터</span>
                  </div>
                </div>

                <div className="mode-option" onClick={() => handleUploadModeSelect('replace')}>
                  <div className="mode-icon replace">
                    <RefreshCw size={24} />
                  </div>
                  <div className="mode-content">
                    <h4>교체 (Replace)</h4>
                    <p>기존 데이터를 모두 삭제하고 새 데이터로 교체합니다.</p>
                    <span className="mode-result">결과: {parsedData.length}개 데이터</span>
                  </div>
                </div>

                <div className="mode-option" onClick={() => handleUploadModeSelect('merge')}>
                  <div className="mode-icon merge">
                    <FileSpreadsheet size={24} />
                  </div>
                  <div className="mode-content">
                    <h4>병합 (Merge)</h4>
                    <p>중복되는 데이터는 업데이트하고, 새로운 데이터는 추가합니다.</p>
                    <span className="mode-result">결과: 중복 제거 후 데이터</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-outline"
                onClick={() => {
                  setShowUploadModeModal(false);
                  setParsedData([]);
                  setSelectedFile(null);
                }}
              >
                취소
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .agent-settlement-container {
          padding: 20px;
          margin: 0 auto;
          margin-top: 60px;
        }


        .month-selector {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .month-select {
          padding: 8px 12px;
          border: 1px solid #d1d5db;
          border-radius: 6px;
          font-size: 14px;
          min-width: 120px;
          width: auto;
        }

        .month-status {
          padding: 6px 12px;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 600;
          text-align: center;
          min-width: 60px;
        }

        .status-active {
          background: #d1fae5;
          color: #065f46;
          border: 1px solid #a7f3d0;
        }

        .status-inactive {
          background: #fee2e2;
          color: #991b1b;
          border: 1px solid #fecaca;
        }

        .month-stats {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 20px;
          margin-bottom: 30px;
        }

        .stat-card {
          background: white;
          padding: 20px;
          border-radius: 8px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          border: 1px solid #d1d5db;
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .stat-icon {
          width: 48px;
          height: 48px;
          border-radius: 8px;
          background: #f0f9ff;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #0369a1;
        }

        .stat-content {
          flex: 1;
        }

        .stat-value {
          font-size: 24px;
          font-weight: 600;
          color: #1f2937;
        }

        .stat-label {
          font-size: 14px;
          color: #6b7280;
        }

        .action-buttons {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
        }

        .btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 10px 16px;
          border-radius: 6px;
          font-size: 14px;
          font-weight: 500;
          text-decoration: none;
          border: none;
          cursor: pointer;
          transition: all 0.2s;
        }

        .btn-primary {
          background: #3b82f6;
          color: white;
        }

        .btn-primary:hover {
          background: #2563eb;
        }

        .btn-outline {
          background: white;
          color: #374151;
          border: 1px solid #d1d5db;
        }

        .btn-outline:hover {
          background: #f9fafb;
        }

        .btn-disabled {
          background: #f3f4f6;
          color: #9ca3af;
          border: 1px solid #e5e7eb;
          cursor: not-allowed;
          opacity: 0.6;
        }

        .btn-disabled:hover {
          background: #f3f4f6;
          color: #9ca3af;
        }

        .search-section {
          margin-bottom: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 20px;
          flex-wrap: wrap;
        }

        .search-box {
          position: relative;
          max-width: 400px;
          flex: 1;
          min-width: 300px;
        }

        .search-box svg {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: #9ca3af;
        }

        .search-box input {
          width: 100%;
          padding: 10px 12px 10px 40px;
          border: 1px solid #d1d5db;
          border-radius: 6px;
          font-size: 14px;
        }

        .data-table {
          background: white;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }

        .table-header {
          padding: 16px 20px;
          background: #f9fafb;
          border-bottom: 1px solid #e5e7eb;
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }

        .data-table table {
          width: 100%;
          border-collapse: collapse;
        }

        .data-table th,
        .data-table td {
          padding: 12px 16px;
          text-align: left;
          border-bottom: 1px solid #e5e7eb;
        }

        .data-table th {
          background: #f9fafb;
          font-weight: 600;
          color: #374151;
        }

        .data-table tbody tr:hover {
          background: #f9fafb;
        }

        .amount {
          font-weight: 600;
          color: #059669;
        }

        .status {
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 500;
        }

        .status-completed {
          background: #d1fae5;
          color: #065f46;
        }

        .status-pending {
          background: #fef3c7;
          color: #92400e;
        }

        .status-cancelled {
          background: #fee2e2;
          color: #991b1b;
        }

        .status-unknown {
          background: #f3f4f6;
          color: #6b7280;
        }

        .btn-icon {
          padding: 6px;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }

        .btn-danger {
          background: #fee2e2;
          color: #dc2626;
        }

        .btn-danger:hover {
          background: #fecaca;
        }

        .loading-state,
        .empty-state {
          text-align: center;
          padding: 40px;
          color: #6b7280;
        }

        .loading-spinner {
          width: 20px;
          height: 20px;
          border: 2px solid #e5e7eb;
          border-top: 2px solid #3b82f6;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto 10px;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .toast {
          position: fixed;
          top: 20px;
          right: 20px;
          z-index: 1000;
          max-width: 400px;
          min-width: 300px;
          animation: slideInRight 0.3s ease-out;
        }

        .toast-content {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          padding: 16px;
          border-radius: 8px;
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          backdrop-filter: blur(10px);
        }

        .toast-success .toast-content {
          background: rgba(16, 185, 129, 0.95);
          color: white;
          border: 1px solid rgba(16, 185, 129, 0.2);
        }

        .toast-error .toast-content {
          background: rgba(239, 68, 68, 0.95);
          color: white;
          border: 1px solid rgba(239, 68, 68, 0.2);
        }

        .toast-icon {
          flex-shrink: 0;
          margin-top: 2px;
        }

        .toast-message {
          flex: 1;
        }

        .toast-title {
          font-weight: 600;
          font-size: 14px;
          margin-bottom: 4px;
        }

        .toast-text {
          font-size: 13px;
          opacity: 0.9;
          line-height: 1.4;
        }

        .toast-close {
          background: none;
          border: none;
          color: white;
          font-size: 18px;
          font-weight: bold;
          cursor: pointer;
          padding: 0;
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          transition: background-color 0.2s;
          flex-shrink: 0;
        }

        .toast-close:hover {
          background: rgba(255, 255, 255, 0.2);
        }

        @keyframes slideInRight {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }

        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 20px;
          box-sizing: border-box;
        }

        .modal {
          background: white;
          border-radius: 12px;
          width: 100%;
          max-width: 500px;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          margin: auto;
          position: relative;
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px 24px;
          border-bottom: 1px solid #e5e7eb;
        }

        .modal-header h3 {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          color: #1f2937;
        }

        .btn-close {
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: #6b7280;
          padding: 0;
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .btn-close:hover {
          color: #374151;
        }

        .modal-body {
          padding: 24px;
        }

        .modal-footer {
          display: flex;
          justify-content: flex-end;
          gap: 12px;
          padding: 20px 24px;
          border-top: 1px solid #e5e7eb;
        }

        .form-group {
          margin-bottom: 20px;
        }

        .form-group label {
          display: block;
          margin-bottom: 6px;
          font-weight: 500;
          color: #374151;
        }

        .form-group input,
        .form-group select {
          width: 100%;
          padding: 10px 12px;
          border: 1px solid #d1d5db;
          border-radius: 6px;
          font-size: 14px;
        }

        .form-group input:focus,
        .form-group select:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }

        .form-help {
          font-size: 12px;
          color: #6b7280;
          margin-top: 4px;
        }


        .preview-section {
          background: white;
          border-radius: 8px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          margin-bottom: 20px;
        }

        .preview-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px 24px;
          border-bottom: 1px solid #e5e7eb;
        }

        .preview-header h3 {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          color: #1f2937;
        }

        .preview-actions {
          display: flex;
          gap: 12px;
        }

        .preview-info {
          padding: 16px 24px;
          background: #f9fafb;
          border-bottom: 1px solid #e5e7eb;
        }

        .file-info {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 8px;
        }

        .file-info svg {
          color: #0369a1;
        }

        .upload-mode-badge {
          background: #3b82f6;
          color: white;
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 500;
          margin-left: 8px;
        }

        .upload-mode-info {
          background: #f0f9ff;
          padding: 16px;
          border-radius: 8px;
          margin-bottom: 20px;
        }

        .upload-mode-info p {
          margin: 4px 0;
          font-size: 14px;
        }

        .upload-mode-options {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .mode-option {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 16px;
          border: 2px solid #e5e7eb;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.2s;
        }

        .mode-option:hover {
          border-color: #3b82f6;
          background: #f0f9ff;
        }

        .mode-icon {
          width: 48px;
          height: 48px;
          border-radius: 8px;
          background: #e0f2fe;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #0369a1;
        }

        .mode-icon.replace {
          background: #fef3c7;
          color: #d97706;
        }

        .mode-icon.merge {
          background: #d1fae5;
          color: #059669;
        }

        .mode-content {
          flex: 1;
        }

        .mode-content h4 {
          margin: 0 0 8px 0;
          font-size: 16px;
          font-weight: 600;
          color: #1f2937;
        }

        .mode-content p {
          margin: 0 0 8px 0;
          font-size: 14px;
          color: #6b7280;
        }

        .mode-result {
          font-size: 12px;
          color: #3b82f6;
          font-weight: 500;
        }

        .preview-info p {
          margin: 4px 0;
          font-size: 14px;
        }

        .preview-table {
          max-height: 500px;
          overflow-y: auto;
        }

        .preview-table table {
          width: 100%;
          border-collapse: collapse;
        }

        .preview-table th,
        .preview-table td {
          padding: 8px 12px;
          text-align: left;
          border-bottom: 1px solid #e5e7eb;
          font-size: 13px;
        }

        .preview-table th {
          background: #f9fafb;
          font-weight: 600;
          position: sticky;
          top: 0;
        }

        .invalid-row {
          background-color: #fef2f2;
        }

        .invalid-row td {
          color: #dc2626;
        }

        .invalid-bank-name {
          background-color: #fef2f2 !important;
          color: #dc2626 !important;
          position: relative;
        }

        .bank-error-tooltip {
          position: absolute;
          background: #dc2626;
          color: white;
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 11px;
          white-space: nowrap;
          z-index: 10;
          top: -30px;
          left: 0;
          opacity: 0;
          transition: opacity 0.2s;
          pointer-events: none;
        }

        .invalid-bank-name:hover .bank-error-tooltip {
          opacity: 1;
        }

        @media (max-width: 768px) {
          .month-stats {
            grid-template-columns: 1fr;
          }

          .search-section {
            flex-direction: column;
            align-items: stretch;
          }

          .search-box {
            min-width: auto;
            max-width: none;
          }

          .action-buttons {
            justify-content: center;
          }

          .btn {
            justify-content: center;
          }

          .data-table {
            overflow-x: auto;
          }

          .preview-table {
            overflow-x: auto;
          }
        }
      `}</style>
    </div>
  );
}

export default AgentSettlement;